const View = require("presto-ui").baseView;

class SFP extends View {

	constructor(props, children, state) {
		super(props, children, state);
		this.shouldCacheScreen = false;

		this.setIds(['Content']);

		this.style_Register = {
			onClick: this.onClickRegister.bind(this)
		}

		this.style_Forum = {
			onClick: this.onClickForum.bind(this)
		}

		this.style_Group_5 = {
			onClick: this.onClickHome.bind(this)
		}

		this.style_Takethecours = {
			onClick: this.onClickTake.bind(this)
		}

		this.style_KnowmoreGroup10 = {
			onClick: this.onClickKnow.bind(this)
		}

		this.style_What_is_Presto_ = {
			onClick: this.onClickPresto.bind(this)
		}
	}

	onClickHome(){
		var cmd = this.cmd({id : this.idSet.Content, visibility: "gone"});
		Android.runInUI(cmd,null);
		document.getElementById("content").scrollTo(0,0);

		if (window.__WIDTH <=600)
			window.__duiShowScreen(null,{screen:"MobileHome2"});
		else
			window.__duiShowScreen(null,{screen:"Home2"});
	}

	onClickRegister() {
		window.open("https://form.jotform.co/73251234628858",'_blank');
	}

	onClickForum() {
		window.open("https://muut.com/purescript-presto",'_blank');
	}

	onClickTake() {
		window.open("https://juspay.gitbooks.io/presto-guide/content/",'_blank');
	}

	onClickPresto() {
		var cmd = this.cmd({id : this.idSet.Content, visibility: "gone"});
		Android.runInUI(cmd,null);
		document.getElementById("content").scrollTo(0,0);

		if (window.__WIDTH <=600)
			window.__duiShowScreen(null,{screen:"MobilePresto"});
		else
			window.__duiShowScreen(null,{screen:"Presto"});
	}

	onClickKnow() {
		var cmd = this.cmd({id : this.idSet.Content, visibility: "gone"});
		Android.runInUI(cmd,null);
		document.getElementById("content").scrollTo(0,0);

		if (window.__WIDTH <=600)
			window.__duiShowScreen(null,{screen:"MobileProject"});
		else
			window.__duiShowScreen(null,{screen:"Project"});
	}

}

module.exports = SFP;



// WEBPACK FOOTER //
// ./controller/pages/Main/SFP.js